import { useTranslation } from "react-i18next";

// Flag SVG Components
const UKFlag = () => (
  <svg width="32" height="24" viewBox="0 0 32 24" className="rounded shadow-md">
    <rect width="32" height="24" fill="#012169"/>
    <path d="M0 0L32 24M32 0L0 24" stroke="white" strokeWidth="4"/>
    <path d="M0 0L32 24M32 0L0 24" stroke="#C8102E" strokeWidth="2.5"/>
    <path d="M16 0V24M0 12H32" stroke="white" strokeWidth="8"/>
    <path d="M16 0V24M0 12H32" stroke="#C8102E" strokeWidth="5"/>
  </svg>
);

const DutchFlag = () => (
  <svg width="32" height="24" viewBox="0 0 32 24" className="rounded shadow-md">
    <rect width="32" height="8" fill="#AE1C28"/>
    <rect y="8" width="32" height="8" fill="white"/>
    <rect y="16" width="32" height="8" fill="#21468B"/>
  </svg>
);

const FrenchFlag = () => (
  <svg width="32" height="24" viewBox="0 0 32 24" className="rounded shadow-md">
    <rect width="10.67" height="24" fill="#002395"/>
    <rect x="10.67" width="10.67" height="24" fill="white"/>
    <rect x="21.33" width="10.67" height="24" fill="#ED2939"/>
  </svg>
);

const SpanishFlag = () => (
  <svg width="32" height="24" viewBox="0 0 32 24" className="rounded shadow-md">
    <rect width="32" height="24" fill="#FFC400"/>
    <rect y="6" width="32" height="12" fill="#AA151B"/>
  </svg>
);

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', FlagComponent: UKFlag },
    { code: 'nl', name: 'Nederlands', FlagComponent: DutchFlag },
    { code: 'fr', name: 'Français', FlagComponent: FrenchFlag },
    { code: 'es', name: 'Español', FlagComponent: SpanishFlag }
  ];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <div className="flex items-center gap-3">
      {languages.map((language) => {
        const FlagComponent = language.FlagComponent;
        return (
          <button
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            className={`transition-all duration-200 hover:scale-110 border-2 rounded ${
              i18n.language === language.code 
                ? 'opacity-100 scale-110 border-[#1a7a8a] shadow-lg' 
                : 'opacity-60 hover:opacity-100 border-transparent'
            }`}
            title={language.name}
            aria-label={`Switch to ${language.name}`}
          >
            <FlagComponent />
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
